import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as entitiesApi from "@/lib/api/entities";
import { useCurrentUser } from "@/hooks/use-current-user";
import { queryKeys } from "@/lib/query-keys";
import type { ProcessNoteEntitiesInput } from "api-schemas";

type ProcessNoteEntitiesPayload = Omit<ProcessNoteEntitiesInput, "userId">;

export const useProcessNoteEntitiesMutation = () => {
  const queryClient = useQueryClient();
  const { userId } = useCurrentUser();

  return useMutation({
    mutationFn: async (payload: ProcessNoteEntitiesPayload) => {
      return entitiesApi.processNoteEntities({
        noteId: payload.noteId,
        userId,
        metadata: payload.metadata,
      });
    },
    onSuccess: (_data, variables, _context) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.notes.all });
      queryClient.invalidateQueries({
        queryKey: queryKeys.notes.entities(variables.noteId),
      });
    },
    onError: (error) => {
      console.error("Error processing note entities:", error);
    },
  });
};
